
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Controlador as ControladorBusqueda } from '../../controlador-cursos';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        public get ControladorPrincipal() { return Model; }
        public get Controlador() { return ControladorBusqueda; }
        public get Buscador() { return ControladorBusqueda.Buscador; }
        public get Filtros() { return this.Buscador.Filtros; }

        public Estado: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Estado = this.Buscador.Estado;
            this.Eventos.push( this.Buscador.onEstado.subscribe( () => this.Estado = this.Buscador.Estado ) );
            this.Eventos.push( this.Buscador.onActualizar.subscribe( this.Iniciar ) );
        }


        Bloqueado: boolean = true;
        Pagina: number = -1;
        @Watch( 'Pagina' )
        onPagina()
        {
            if ( this.Buscador.Paginacion )
            {
                if ( this.Pagina != this.Buscador.Paginacion.Pagina )
                {
                    this.Bloqueado = true;
                    this.Buscador.Buscar( this.Pagina );
                }

            }

        }

        Iniciar()
        {
            this.Estado = this.Buscador.Estado;
            if ( this.Estado == 'ok' )
            {
                this.Pagina = this.Buscador.Paginacion.Pagina;
                this.Bloqueado = false;
            }

        }
    }
